import { render } from "./AppHeaderDropdownCid.vue?vue&type=template&id=2989cb2b"
import script from "./AppHeaderDropdownCid.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownCid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__